module.exports = __webpack_public_path__ + "img/collect.2e7bb93f.svg";